import styled, { css } from 'styled-components';

export const StyledInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
  width: 100%;
  position: relative;
  p {
    color: var(--color-danger);
    font-size: var(--font-size-sm);
  }
`;

export const StyledInputWrapper = styled.div`
  position: relative;
`;

export const StyledInput = styled.input<{ $size: 'small' | 'medium' | 'large', $password?: boolean }>`
  width: 100%;
  border: 1px solid var(--color-border);
  background-color: var(--color-background);
  color: var(--color-foreground);
  font-family: var(--font-family-base);
  border-radius: var(--radius-md);
  transition: all var(--transition-fast);
  outline: none;

  &::placeholder {
    color: var(--color-secondary);
    opacity: 0.6;
  }

  &:hover {
    border-color: var(--color-primary);
  }

  &:focus {
    border-color: var(--color-primary);
    box-shadow: 0 0 0 2px rgba(53, 182, 120, 0.2);
  }

  &:disabled {
    background-color: var(--color-border);
    color: var(--color-secondary);
    cursor: not-allowed;
  }

  ${({ $size }) => {
    switch ($size) {
      case 'small':
        return css`
          padding: var(--spacing-xs) var(--spacing-sm);
        `;
      case 'large':
        return css`
          padding: var(--spacing-md) var(--spacing-lg);
        `;
      case 'medium':
      default:
        return css`
          padding: var(--spacing-sm) var(--spacing-md);
        `;
    }
  }}

  ${({ $password }) => $password ? 'padding-right: 50px;' : ''}
`;

export const StyledTypeSwitch = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  padding: 0 var(--spacing-md);
`;
